import axios from "axios";
import { getCookie } from "@util/cookie";
import { GetListInvoiceParams } from "@type/invoice";

const apiURL = import.meta.env.VITE_TALENT_AI_BE_BASE_URL;

export async function getListInvoices(params: GetListInvoiceParams): Promise<any> {
    const token = getCookie("authToken");

    return await axios({
        url: `${apiURL}/invoices/list`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        params: params,
    });
}

export async function getDetailInvoice(invoice_id: string): Promise<any> {
    const token = getCookie("authToken");

    return await axios({
        url: `${apiURL}/invoices/${invoice_id}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
}